import type { TipoArredondamento, TipoFinais } from '../../../@types/IPA/PrecoPsicologico';

export const LABELS_ARREDONDAMENTO: Record<TipoArredondamento, string> = {
  MAIS_PROXIMO: 'valor mais próximo',
  SEMPRE_PARA_CIMA: 'sempre para cima',
  SEMPRE_PARA_BAIXO: 'sempre para baixo',
};

export const LABELS_DIGITOS: Record<TipoFinais, string> = {
  1: 'um dígito',
  2: 'dois dígitos',
  3: 'três dígitos',
  4: 'quatro dígitos',
  5: 'cinco dígitos',
};

// Valor mínimo de "valorAte" exigido por cada tipo de dígitos.
// Usado tanto pela UI (chips habilitados em TipoSeletorDigitos)
// quanto pela validação do schema (FaixaDePrecoForm/schema.ts).
export const MIN_VALOR_ATE_POR_TIPO: Record<TipoFinais, number> = {
  1: 0,
  2: 0,
  3: 10,
  4: 100,
  5: 1000,
};

export function capitalizar(texto: string): string {
  if (!texto) return texto;
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}

export const URL_VIDEO_TUTORIAL = 'https://www.youtube.com/embed/F0HEyA16zm4';
